// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FP8s","col":"styles_col__2_ReG"};